import styled from "styled-components";

export const LayoutContainer = styled.div`
  width: 100vw;
  display: flex;
  height: 91vh;
`;
